


import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setAccountOpeningStep } from '../../redux/accountOpening';
import '../OtpDialog/OtpDialog.css'
import AuthCode from 'react-auth-code-input';
import { getLocalStorageItem, setLocalStorageItem } from '../../utils/localStorage';
import axios from 'axios';
import { baseUrl } from '../../utils/baseUrl';
import * as toast from '../../utils/makeToast';
import styles from './style.module.css';
import useOtpResendCountdown from '../../customHooks/useOtpResendCountdown';

interface OtpDialogModalProps {
  openModal?: boolean;
  closeModal?: () => void;
  routeTo?: string;
}

const OtpDialogModal: React.FC<OtpDialogModalProps> = ({ openModal = false, closeModal, routeTo }) => {
    const {countdownStop,countdownStr,resetTimer} = useOtpResendCountdown()
    const [result, setResult] = useState('');
    const handleOnChange = (res: string) => {
        setResult(res);
    };

  const [validating, setValidating] = useState(false);
  const [showTimer, setShowTimer] = useState(false);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );

  const dispatch = useDispatch();

  const resendOtp = () => {
    setValidating(true);
    let resendOtpPayload = {
      phoneNumber: userDetails.phoneNumber,
      customerName: `${userDetails.firstName} ${userDetails.lastName}`,
      bvn: userDetails.bvn,
    };
    setShowTimer(true);

        axios.post(`${baseUrl}Authentication/SendOTP`, resendOtpPayload)
        .then((response) => {
            toast.successToast(response.data.message)
          
            setValidating(false)
            resetTimer()
        })
        .catch((err) => {
            setValidating(false)
            toast.errorToast('something went wrong')
        })
    }

  const handleVerifyOTP = () => {
    setValidating(true);
    let validateOTPPayload = {
      phoneNumber: userDetails.phoneNumber,
      otp: result,
      bvn: userDetails.bvn,
    };
    setShowTimer(true);
    axios
      .post(`${baseUrl}Authentication/validateOTP`, validateOTPPayload)
      .then((response) => {
        if (response.data.UserDetails && response.data.accessToken) {
          let userInfo = getLocalStorageItem("userDetails") || {};

          setLocalStorageItem("accessToken", response.data.accessToken);
          setLocalStorageItem(
            "userDetails",
            JSON.stringify({ ...userInfo, ...response.data.UserDetails })
          );

          toast.successToast(response.data.message);
          dispatch(setAccountOpeningStep(`${routeTo}`));
        } else {
          toast.errorToast(response.data.message);
        }
        setValidating(false);
      })
      .catch((err) => {
        setValidating(false);
        toast.errorToast("something went wrong");
      });
  };

  return (
    <>
      {openModal && (
        <div className={styles.overlay}>
          <div className={styles.modal}>
            <div className={styles.modalContent}>
              <span className={styles.close} onClick={closeModal}>
                &times;
              </span>
              <div className={styles.container}>
                <div>
                  <div className=" card-form pl-5 pr-5 ">
                    <div className="card-body text-center">
                      <h4 className="card-title text-center pt-4 mt-5">
                        Enter OTP
                      </h4>
                      <p className="text-muted">
                        An OTP has been sent to the mobile number and email
                        captured in <br />
                        your BVN. Kindly enter the OTP to proceed.
                      </p>

                      <div className="mt-4 mb-4">
                        <AuthCode
                          inputClassName="text-center"
                          placeholder="*"
                          length={4}
                          allowedCharacters="numeric"
                          onChange={handleOnChange}
                        />
                      </div>

                                        {validating ? 
                                            <div className="spinner-border text-gold mb-4" role="status">
                                                <span className="sr-only"></span>
                                            </div>:
                                            <button disabled={result.length !== 4} type="submit" className="btn btn-filled-red mb-4 proceed-btn" onClick={handleVerifyOTP}>Proceed</button>
                                        }

                                        <p>{countdownStop?<small>Did not get the OTP? <span className="font-weight-bold">
                                                    <u className="cursor-pointer" onClick={resendOtp} >Resend OTP</u></span>
                                            </small>:<small>Resend code in {countdownStr}</small>}
                                            
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    )
}

export default OtpDialogModal;
